import { useSyncExternalStore } from 'react';

const cache = new Map<string, MediaQueryList>();

const listFor = (query: string): MediaQueryList => {
  let mql = cache.get(query);
  if (!mql) {
    mql = window.matchMedia(query);
    cache.set(query, mql);
  }
  return mql;
};

/** live `matchMedia` result; `false` during SSR / before hydration */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = listFor(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => listFor(query).matches,
    () => false,
  );
}
